



















































import Vue from 'vue';
import SPopup from '../SPopup/SPopup.vue';

/**
 * A dialog component.
 * Do not pass a <button> to the 'activator' slot, it get's wrapped in another button. Use the
 * 'activatorWrapper' and scoped slots instead. See the styleguide examples
 *
 * **NOTE:** The actual modal is SPopup, this just wraps it with an activator button to toggle
 * it open/closed
 */
export default Vue.extend({
  name: 'SDialog',
  components: {
    SPopup,
  },
  props: {
    /**
     * @see src/components/SPopup/SPopup.vue#title
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * @see src/components/SPopup/SPopup.vue#icon
     */
    icon: {
      type: String,
      required: false,
    },
    /**
     * If the dialog should be visible or not
     */
    value: {
      type: Boolean,
      required: false,
    },
    /**
     * If the dialog should be able to be closed by the user
     */
    dismiss: {
      type: Boolean,
      required: false,
      default: true,
      validator(val) {
        if (!val) {
          console.warn('The "dimiss" prop has been deprecated in favour of "persistent"');
        }
        return true;
      },
    },
    persistent: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * @see src/components/SPopup/SPopup.vue#disableClickOutside
     */
    disableClickOutside: {
      type: Boolean,
      required: false,
    },
    /**
     * If true removes padding around the content in the dialog
     */
    flush: {
      type: Boolean,
      required: false,
    },
    /**
     * @see src/components/SPopup/SPopup.vue#width
     */
    width: {
      type: [String, Number],
      required: false,
    },
  },
  data(): any {
    return {
      open: true,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.open = value;
      },
      immediate: true,
    },
    open(open) {
      this.$emit('input', open);
      if (!open) {
        this.$emit('close');
      }
    },
  },
  methods: {
    closeDialog() {
      this.open = false;
    },
    openDialog() {
      this.open = true;
    },
    scrollToTop() {
      this.$refs.popup.scrollToTop();
    },
  },
});
